









































import { Vue, Component, Prop } from "vue-property-decorator";
import showHideInput from "@/components/hideshow-Input.vue";
@Component({
  components: { showHideInput }
})
export default class AppPassword extends Vue {
  psw: string = "";
  @Prop({ default: 4 })
  pswLength!: number;
  @Prop({default : false})
  isError?: boolean;


  tapeCode(val: string) {
    this.psw += val;
  }
  removeCode() {
    this.$emit("clear-error");
    this.psw = this.psw.slice(0, -1);
  }
  deleteCode() {
    this.$emit("clear-error");
    this.psw = "";
    this.$emit("clear-code", this.psw);
  }
  sendCode() {
    console.log(
      "Etape 1 : Envoi de l'event au parent => " + this.psw + " typeof ",
      typeof this.psw
    );
    this.$emit("taped-code", this.psw);
  }

  get isNotMaxLength(): Boolean {
    if (this.pswLength === -1){
      return true
    }else 
   return this.psw.length < this.pswLength
  }
  get isNotEmpty(): Boolean {
    return this.psw.length !== 0;
  }

  get isFull(): Boolean {
    let pswLength = 4 
    if (this.psw.length === pswLength )  { 
      return true
    } else
    return false
  
  }
}
